/* Small progressive additions around the existing Dawn/TQE controllers. */
(() => {
  const dialogLock = () => document.documentElement.classList.toggle(
    'tqe-pdp-dialog-open', Boolean(document.querySelector('dialog.tqe-pdp-dialog[open]'))
  );
  if (!customElements.get('tqe-pdp-dialog')) {
    customElements.define('tqe-pdp-dialog', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const opts = { signal: this.abort.signal };
        const dialog = this.querySelector('dialog');
        const opener = this.querySelector('[data-pdp-open]');
        if (!dialog || !opener) return;
        opener.addEventListener('click', () => {
          dialog.showModal();
          dialogLock();
          dialog.querySelector('[data-pdp-close]')?.focus();
        }, opts);
        dialog.querySelector('[data-pdp-close]')?.addEventListener('click', () => dialog.close(), opts);
        dialog.addEventListener('click', (event) => {
          const r = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
        }, opts);
        dialog.addEventListener('close', () => { dialogLock(); opener.focus({ preventScroll: true }); }, opts);
      }
      disconnectedCallback() { this.abort?.abort(); dialogLock(); }
    });
  }

  if (!customElements.get('tqe-pdp-editorial')) {
    customElements.define('tqe-pdp-editorial', class extends HTMLElement {
      async showVariant(variantId) {
        if (this.dataset.configured !== 'true') return;
        this.pending?.abort();
        this.pending = new AbortController();
        this.hidden = true; // Never retain the previous colour while loading.
        const request = this.pending;
        const url = new URL(this.dataset.productUrl, location.origin);
        url.searchParams.set('variant', variantId);
        url.searchParams.set('section_id', this.dataset.sectionId);
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Editorial section unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = html.getElementById(this.id);
          if (request !== this.pending || !this.isConnected || !next) return;
          this.innerHTML = next.innerHTML;
          this.hidden = next.hidden;
        } catch (error) {
          // Optional imagery fails closed. Native variants, gallery and buying
          // remain fully controlled by the existing product-info component.
          if (error.name !== 'AbortError' && request === this.pending) this.hidden = true;
        }
      }
      disconnectedCallback() { this.pending?.abort(); }
    });
  }

  // Reviewed mapping for the v7 reference bag only. No positional or numeric
  // assumptions are applied to other catalogue products or translated colours.
  const terrasse = {
    '49032682471659': ['42217023013099','42217066397931','42217023635691','42217023799531'],
    '49032682504427': ['42217090187499','42217067544811','42217091203307','42217091760363']
  };
  const views = ['front','model','back','side'];
  function init(root) {
    if (root.dataset.tqePdpReady) return;
    root.dataset.tqePdpReady = 'true';
    const gallery = root.querySelector('media-gallery');
    let count;
    if (gallery) {
      count = document.createElement('p');
      count.className = 'tqe-pdp-count';
      count.setAttribute('aria-hidden', 'true');
      gallery.append(count);
    }
    const updateCount = () => {
      if (!count) return;
      const thumbs = [...gallery.querySelectorAll('[data-target]')].filter(x => !x.hasAttribute('data-tqe-media-excluded'));
      const current = thumbs.findIndex(x => x.querySelector('[aria-current="true"]'));
      count.hidden = thumbs.length < 2;
      count.textContent = `${Math.max(0,current) + 1} / ${thumbs.length}`;
    };
    const applyGallery = variant => {
      if (!gallery) return;
      const ids = root.dataset.productId === '9805144686827' ? terrasse[String(variant)] : null;
      gallery.querySelectorAll('li[data-media-id], li[data-target]').forEach(el => {
        const id = (el.dataset.mediaId || el.dataset.target).split('-').pop();
        const index = ids?.indexOf(id) ?? -1;
        el.toggleAttribute('data-tqe-media-excluded', Boolean(ids && index < 0));
        if (index >= 0) el.dataset.tqeView = views[index];
      });
      // Native modal contains original un-cropped images of the selected colour.
      const nativeModal = document.getElementById(`ProductModal-${root.dataset.section}`);
      nativeModal?.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach(el => {
        el.toggleAttribute('data-tqe-media-excluded', Boolean(ids && !ids.includes(el.dataset.mediaId)));
      });
      gallery.querySelectorAll('slider-component').forEach(slider => slider.resetPages?.());
      updateCount();
    };
    const current = root.querySelector('product-form input[name="id"]')?.value;
    applyGallery(current);
    const observer = new MutationObserver(updateCount);
    if (gallery) observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
    let unsubscribe;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data.sectionId !== root.dataset.section || !event.data.variant) return;
        applyGallery(event.data.variant.id);
        const inclusions = root.querySelector('[data-tqe-inclusions]');
        const replacement = event.data.html.getElementById(inclusions?.id);
        if (inclusions && replacement) {
          const opened = [...inclusions.querySelectorAll('details')].map(x => x.open);
          inclusions.innerHTML = replacement.innerHTML;
          inclusions.querySelectorAll('details').forEach((x,i) => { x.open = Boolean(opened[i]); });
        }
        document.querySelectorAll('tqe-pdp-editorial').forEach(el => el.showVariant(event.data.variant.id));
      });
    }
    root.tqePdpDispose = () => { observer.disconnect(); unsubscribe?.(); delete root.dataset.tqePdpReady; };
  }
  function boot() { document.querySelectorAll('product-info.tqe-pdp-v7').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('product-info.tqe-pdp-v7').forEach(x => x.tqePdpDispose?.()));
})();
